<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Add Transport</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card>
        <ion-card-content>
            <ion-list>
                <ion-radio-group>
                    <ion-list-header>
                        <ion-label><h2>Transport</h2></ion-label>
                    </ion-list-header>
                    <ion-item *ngFor="let trans of transports;">
                        <ion-label><p>{{ trans.comment }} - {{ trans.plu }}</p></ion-label>
                        <ion-radio slot="end" [value]="trans"
                                   (ionSelect)="selectTransport($event); showInput=true;"></ion-radio>
                    </ion-item>
                </ion-radio-group>
            </ion-list>
        </ion-card-content>
        <ion-item *ngIf="showInput">
            <ion-label>Delivery Charge:</ion-label>
            <ion-input type="number" [(ngModel)]="transport.total" class="ion-text-end"></ion-input>
        </ion-item>
    </ion-card>
    <ion-fab vertical="bottom" horizontal="end" >
        <ion-fab-button (tap)="addTransports()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
